<template>
  <div class="w-full flex flex-col items-center h-screen">
    <div class="m-auto">
      <div class="text-center">
        <InitialStateSVG />
      </div>
      <div class="pt-8 text-center main--content pb-32">
        <p class="text-zt-primary-200 text-xl leading-tight font-normal">
          {{ $t('message.searchComponent.empty.message') }}
        </p>
        <p class="pt-2 text-zt-dark-300 text-lg font-normal">
          {{ $t('message.searchComponent.empty.legend') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import InitialStateSVG from './SVG/InitialSearch.vue'

export default {
  name: 'SearchInitialState',
  components: {
    InitialStateSVG,
  },
}
</script>

<style scoped>
.main--content {
  max-width: 450px;
}
</style>
